<template>
<body>
  <form class="modalContainer active loginModal formsModal">
    <div class="actualModal">
      <router-link to="/index" class="closeModal"><i class="fal fa-times"></i></router-link>
      <div class="modalBodyOfItem">
        <form @submit.prevent="handleSubmit" class="itemBodyLeftModal">
          <h4>Login</h4>
          <div class="inputsContainer">
            <div class="individualInput">
              <h5>Email Address</h5>
              <input v-model="email" type="text" id="email" placeholder="e.g. your@email.com" />
            </div>
            <div class="individualInput">
              <h5>Password</h5>
              <input v-model="password" type="password" id="password" placeholder="*******************" />
            </div>

            <!-- <div class="fgtPs"> -->
            <div style="text-align: right;">
              <router-link to="/forgot" class="forgotPass">Forgot Password?</router-link>
            </div>
          </div>
          <div class="mobileFlex"></div>
          <div class="quickCheckout">
            <button type="submit">Login</button>
          </div>
          <div class="formBtm">
            <router-link to="/signup" class="signUpBtn">Don't have an account? Sign up</router-link>
          </div>
        </form>
      </div>
    </div>
  </form>
</body>
</template>

<script>
export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    handleSubmit(e) {
      const {
        email,
        password
      } = this
      const {
        dispatch
      } = this.$store
      if (email && password) {
        dispatch('auth/login', {
          username: email,
          password
        })

      }
    }

  }

}
</script>
